<template>
  <div class="form">
    <el-form :model="infoForm" ref="infoForm" :rules="rules">
      <el-card class="table-card" style="height: 830px;">
        <el-row :gutter="20" style="height:60px;margin-top:20px">
          <el-col :span="6">
            <div>
              <span class="title">手机号/账号：</span>
              <el-form-item class="value" prop="accountName" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.accountName" maxlength="16" placeholder="手机号/账号"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">姓名：</span>
              <el-form-item class="value" prop="name" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.name" maxlength="16" placeholder="姓名"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">邮箱：</span>
              <el-form-item class="value" prop="email" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.email" maxlength="32" placeholder="邮箱"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">工号：</span>
              <el-form-item class="value" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.employeeId" maxlength="16" placeholder="工号"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="height:60px">
          <el-col :span="6">
            <div>
              <span class="title">职位：</span>
              <el-form-item class="value" style="max-width:240px;display: inline-block;">
                <el-select style="width: 100%" filterable clearable v-model="infoForm.job" size="small" maxlength="16" placeholder="职位" @change="jobSelectChange">
                  <el-option v-for="item in jobOptions" :key="item.id" :value="item.value" :label="item.label"> </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">班组：</span>
              <el-form-item class="value" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.team" maxlength="16" placeholder="班组"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">生日：</span>
              <el-form-item class="value" style="max-width:240px; display: inline-block;">
                <el-date-picker style="display: inline-block;" v-model="infoForm.birthday" type="date" placeholder="选择生日" format="yyyy/MM/dd" value-format="timestamp"> </el-date-picker>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">民族：</span>
              <el-form-item class="value" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.nation" maxlength="16" placeholder="民族"></el-input>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="height:60px">
          <el-col :span="6">
            <div>
              <span class="title">分厂/机组/供应商：</span>
              <el-form-item class="value" style="max-width:240px;display: inline-block;">
                <el-input size="small" v-model="infoForm.vendor" maxlength="16" placeholder="分厂/机组/供应商"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <span class="title">性别：</span>
              <el-form-item class="value" style="max-width:240px;display: inline-block;">
                <el-radio v-model="infoForm.sex" label="0">女</el-radio>
                <el-radio v-model="infoForm.sex" label="1">男</el-radio>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="height:60px" v-if="permission.btn_mission_list">
          <el-col :span="24">
            <div>
              <span class="title">权限：</span>
              <el-form-item class="" style="display: inline-block;">
                <el-checkbox-group v-model="infoForm.responsibleType">
                  <el-checkbox label="采购"></el-checkbox>
                  <el-checkbox label="商务"></el-checkbox>
                  <el-checkbox label="质量"></el-checkbox>
                  <el-checkbox label="管理"></el-checkbox>
                  <el-checkbox label="安全"></el-checkbox>
                  <el-checkbox label="设备故障"></el-checkbox>
                  <el-checkbox label="其他"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row style="height:60px">
          <el-col :span="6" class="button">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button @click="resetAll">重置</el-button>
              <el-button class="pwdButton" @click="showChangePassword">修改密码</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
    <el-dialog title="修改密码" :visible.sync="changePassword" @close="close" width="40%" center>
      <el-form :label-position="labelPosition" label-width="100px" style="max-width:400px;margin:0 auto;" :rules="passwordRules" ref="passwordForm" :model="passwordForm">
        <el-form-item required label="原密码：" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" class="passwordInput" size="large"></el-input>
        </el-form-item>
        <el-form-item required label="新密码：" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" class="passwordInput" size="large"></el-input>
        </el-form-item>
        <el-form-item required label="再次确定：" prop="repeatPassword">
          <el-input v-model="passwordForm.repeatPassword" type="password" class="passwordInput" size="large"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitNewPassword">确定</el-button>
        <el-button @click="resetPassword">重置</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const NodeRSA = require("node-rsa");
import com from "@/util/CommonUtils.js";
export default {
  data() {
    let notOldPassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入新密码"));
      } else if (value == this.passwordForm.oldPassword) {
        callback(new Error("新密码不能与旧密码一致"));
      } else {
        callback();
      }
    };
    let sameNewPassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请再次输入新密码"));
      } else if (value != this.passwordForm.newPassword) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };

    return {
      W: false,
      labelPosition: "right",
      infoForm: {
        accountName: "",
        name: "",
        contact: "",
        email: "",
        roleName: "",
        birthday: "",
        employeeId: "",
        job: "",
        nation: "",
        sex: "",
        team: "",
        vendor: "",
        responsibleType: []
      },
      changePassword: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        repeatPassword: ""
      },
      initialData: "", //原始数据
      passwordRules: {
        newPassword: [
          { validator: notOldPassword, trigger: "blur" },
          { pattern: /^[a-zA-Z0-9]{6,20}$/i, message: "密码必须为6-20位英文或数字", trigger: "blur" }
        ],
        repeatPassword: [{ validator: sameNewPassword, trigger: "blur" }]
      },
      jobOptions: [
        {
          value: "管理员",
          label: "管理员"
        },
        {
          value: "机组主任",
          label: "机组主任"
        },
        {
          value: "一般员工",
          label: "一般员工"
        }
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],

        email: [
          { required: false, message: "请输入email", trigger: "blur" },
          { pattern: /^([a-zA-Z]|\d)(\.|\w|\-)+@([a-zA-Z0-9]|\-)+\.([a-zA-Z]{2,4})$/, message: "请输入正确的邮箱", trigger: "change" }
        ],
        accountName: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3|4|5|8|7|9][0-9]\d{8}$/, message: "请输入正确的手机号码", trigger: "change" }
        ]
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  created() {},
  mounted() {
    this.loadPresonInfo();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 6 : 8;
    }
  },
  methods: {
    //加载用户信息
    loadPresonInfo() {
      let userName = localStorage.getItem("username");
      let token = localStorage.getItem("token");
      this.$RequestUtil.get({
        url: "/api/user/getUser",
        type: "sync",
        params: { userName, token },
        success: res => {
          if (res.data.job == "老板") {
            res.data.job = "管理员";
          }
          this.initialData = res.data;
          this.infoForm.id = res.data.userId;
          this.infoForm.accountName = res.data.accountName;
          this.infoForm.name = res.data.name;
          this.infoForm.contact = res.data.contact;
          this.infoForm.email = res.data.email;
          this.infoForm.roleName = res.data.roleName;
          this.infoForm.birthday = res.data.birthday;
          this.infoForm.employeeId = res.data.employeeId;
          this.infoForm.job = res.data.job;
          this.infoForm.nation = res.data.nation;
          this.infoForm.sex = res.data.sex;
          this.infoForm.team = res.data.team;
          this.infoForm.vendor = res.data.vendor;
          this.infoForm.responsibleType = res.data.responsibleType.map(item => this.unParseType(Number(item)));
        }
      });
    },
    unParseType(num) {
      let val = "";
      switch (num) {
        case 0:
          val = "采购";
          break;
        case 1:
          val = "商务";
          break;
        case 2:
          val = "质量";
          break;
        case 3:
          val = "管理";
          break;
        case 4:
          val = "安全";
          break;
        case 5:
          val = "设备故障";
          break;
        case 6:
          val = "其他";
          break;
        default:
      }
      return val;
    },
    parseType(val) {
      //0-采购 1-商务 2-质量 3-管理 4-安全 5-设备故障 6-其他
      let num = null;
      switch (val) {
        case "采购":
          num = 0;
          break;
        case "商务":
          num = 1;
          break;
        case "质量":
          num = 2;
          break;
        case "管理":
          num = 3;
          break;
        case "安全":
          num = 4;
          break;
        case "设备故障":
          num = 5;
          break;
        case "其他":
          num = 6;
          break;
        default:
      }
      return num;
    },
    parseSex: function(val) {
      if (val.sex == 0) {
        return "女";
      } else {
        return "男";
      }
    },
    jobSelectChange(val) {
      if (val === null || val === 0 || val === "") {
        this.infoForm.job = "";
      } else {
        let arr = this.jobOptions;
        if (arr.length > 0) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val) {
              this.infoForm.job = arr[i].value;
              break;
            }
          }
        }
      }
    },
    //打开修改密码界面
    showChangePassword() {
      this.changePassword = true;
    },
    //提交修改后的用户信息
    onSubmit() {
      this.infoForm.responsibleType = this.infoForm.responsibleType.map(item => this.parseType(item)).filter(item => item != null);
      let infoForm = this.infoForm;

      this.$refs["infoForm"].validate(valid => {
        if (valid) {
          this.$RequestUtil.post({
            url: "/api/user/updateSelf",
            type: "sync",
            params: infoForm,
            success: res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功"
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            }
          });
        }
      });
    },
    //重置信息
    resetAll() {
      this.infoForm.id = this.initialData.userId;
      this.infoForm.accountName = this.initialData.accountName;
      this.infoForm.name = this.initialData.name;
      this.infoForm.contact = this.initialData.contact;
      this.infoForm.email = this.initialData.email;
      this.infoForm.roleName = this.initialData.roleName;
      this.infoForm.birthday = this.initialData.birthday;
      this.infoForm.employeeId = this.initialData.employeeId;
      this.infoForm.job = this.initialData.job;
      this.infoForm.nation = this.initialData.nation;
      this.infoForm.sex = this.initialData.sex;
      this.infoForm.team = this.initialData.team;
      this.infoForm.vendor = this.initialData.vendor;
      this.infoForm.responsibleType = this.initialData.responsibleType.map(item => this.unParseType(Number(item)));
    },

    //提交修改后的密码
    submitNewPassword() {
      this.$refs["passwordForm"].validate(valid => {
        if (valid) {
          // let pubKey = new NodeRSA('-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkH+yqmoClAZ65dP9jfyUXNOTxKBOkR8OrquWjmhUccGdYeT3tnTts/V/HTy5KeSzgHjurWjydfhG49oI/wZoI7+pEIz5G+44dyb9FD1cbYVHyuUddKc2UcIV65jjFYel35TphXzAejXG8mKHGYlmGc1MInBjAIkk24JnWUZPbK15llqvDxenzGS6GAlS5+PcjkMvsNiSB0fbJMdyJ5jK9pIlpLhb33HwS5fiW9YxdDPmRqfAuA7KF8X93LxDGpxb3gyMjVMpp3BcSlkicdDmo4PJ96BzK4pIfaa73TDBgCO8gF3W1XElwrYttrdbqZN32fGbef0pSgca4e54BOniWwIDAQAB-----END PUBLIC KEY-----','pkcs8-public-pem');
          // pubKey.setOptions({encryptionScheme: 'pkcs1'});
          // let newPassword = pubKey.encrypt(this.passwordForm.newPassword, 'base64','utf-8');
          // let oldPassword = pubKey.encrypt(this.passwordForm.oldPassword, 'base64','utf-8');
          let newPassword = this.passwordForm.newPassword;
          let oldPassword = this.passwordForm.oldPassword;
          this.$RequestUtil.post({
            url: "/api/user/updatePassword",
            type: "sync",
            params: { newPassword, oldPassword },
            success: res => {
              if (res.code == -1) {
                this.$alert(res.msg, {
                  confirmButtonText: "确定",
                  showClose: false
                });
              } else if (res.code == 0) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.changePassword = false;
                this.resetPassword();
                localStorage.removeItem("token");
                localStorage.removeItem("username");
                localStorage.removeItem("permission");
                this.$store.commit("changeLogOUtStatus", true);
                this.$store.commit("reload_store"); //清除state中状态数据
                this.$router.push({ path: "/Login" });
              }
            }
          });
        }
      });
    },
    resetPassword() {
      this.$refs["passwordForm"].resetFields();
    },
    close() {
      this.$refs["passwordForm"].resetFields();
      this.showClose = false;
    }
  }
};
</script>
<style scoped>
.form {
  width: 100%;
  margin: 2px auto 0;
}
.button {
  margin-top: 53px;
  margin-left: 41.6667%;
}
.pwdButton {
  background-color: #ff4066;
  color: #fff;
}
/* .password{
        width:60%;
        margin:0 17%
    }
    .passwordButton{
        margin: 31px 0 0 45%
    } */
@media screen and (max-width: 2000px) {
  .form .value {
    width: 240px;
  }
}
@media screen and (max-width: 1440px) {
  .button {
    margin-left: 38.6667%;
  }
  .form {
    height: 640px;
  }
  .form .value {
    width: 177px;
  }
}
@media screen and (max-width: 1366px) {
  .form {
    height: 440px;
    margin-top: 0px;
  }
  .form .value {
    width: 177px;
  }
  .form .el-date-editor.el-input,
  .form .el-date-editor.el-input__inner {
    width: 177px;
  }
}
.title {
  display: inline-block;
  width: 137px;
  text-align: right;
}
</style>
<style>
@media screen and (max-width: 2000px) {
  .form .el-date-editor.el-input,
  .form .el-date-editor.el-input__inner {
    width: 240px;
  }
}
@media screen and (max-width: 1500px) {
  .form .el-date-editor.el-input,
  .form .el-date-editor.el-input__inner {
    width: 177px;
  }
}
.passwordInput .el-input__inner {
  border-radius: 10px;
}
/*.form .el-dialog__title{
        font-size:22px;
        margin-left:45%
    }
    .password .el-form-item--small .el-form-item__label{
        line-height:40px
    }
    .button .el-button--small,.passwordButton .el-button--small{
        border-radius:5px
    } */
</style>



// WEBPACK FOOTER //
// src/views/PersonInfo.vue